import {
  Directive,
  inject,
  Input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Role, RoleService } from '@perval/shared';
import { AccessService } from '../../authentification/services/access/access.service';

@Directive({
  selector: '[appHasAccess]',
  standalone: true,
})
export class HasAccessDirective {
  private readonly templateRef = inject(TemplateRef<any>);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly roleService = inject(RoleService);
  private readonly accessService = inject(AccessService);

  private hasView = false;

  @Input() set appHasAccess(roles: Role[]) {
    this.updateView(roles);
  }

  private updateView(requiredRoles: Role[]): void {
    const hasAccess = this.accessService.hasAccess(
      requiredRoles,
      this.roleService.currentUserRoles,
    );

    if (hasAccess && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasAccess && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
